import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { i18n } from '@lingui/core';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { resetSearchFilters } from 'actions/search';
import { getFilterSummarySelector } from 'selectors/search';

import ButtonGroup from 'components/ui/button/ButtonGroup';
import DeletableLabel from 'components/ui/button/DeletableLabel';

import { capitalize } from 'utils/helpers';

import * as svars from 'assets/style/variables';

import { useAnalysisTagFields } from '../useAnalysisFields';
import { SEARCH_STATIC_FILTERS } from './BasicFilters';

const Container = styled.span`
  overflow-x: auto;
  margin: auto 0;
  margin: 0 ${svars.spaceNormalLarge};
  padding: ${svars.spaceNormal} 0;
  white-space: pre;

  ${svars.thinScrollbarCss}
`;

function FiltersDeleteGroup({ disabled, shouldCallOnChangeOnMount }) {
  const dispatch = useDispatch();
  const tagFields = useAnalysisTagFields();
  const getFilterSummary = useSelector(getFilterSummarySelector);
  const onFilterReset = useCallback(
    (_, { value: keys, isTag }) =>
      dispatch(resetSearchFilters(keys, null, null, true, isTag)),
    []
  );
  const items = [
    ...SEARCH_STATIC_FILTERS.map(({ title, keys }) => {
      const summary = getFilterSummary(keys, false);
      return {
        key: keys[0],
        keys,
        isTag: false,
        value: keys,
        labelPosition: 'right',
        label: summary
          ? `${capitalize(i18n._(title))} : ${i18n._(summary)}`
          : '',
        summary,
      };
    }),
    ...tagFields.map(({ id, label }) => {
      const summary = getFilterSummary(id, true);
      return {
        key: id,
        keys: [id],
        isTag: true,
        value: [id],
        label: `${label} : ${summary}`,
        summary,
      };
    }),
  ].filter(({ summary }) => summary && summary !== '-');
  return (
    <Container>
      <ButtonGroup
        buttonBottomPadded
        as={DeletableLabel}
        items={items}
        disabled={disabled}
        onChange={onFilterReset}
        shouldCallOnChangeOnMount={shouldCallOnChangeOnMount}
        style={{
          display: 'inline-flex',
          margin: `0 ${svars.spaceMedium}`,
        }}
      />
    </Container>
  );
}

FiltersDeleteGroup.propTypes = {
  disabled: PropTypes.bool,
  shouldCallOnChangeOnMount: PropTypes.bool,
};
FiltersDeleteGroup.defaultProps = {
  disabled: false,
  shouldCallOnChangeOnMount: true,
};

export default FiltersDeleteGroup;
